import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import useAdminData from "../hooks/useAdminData";

//  Styles
import "./ProjectBox.scss";

const ProjectBox = ({ project, index }) => {
    const { deleteProject } = useAdminData();
    const [prj, setPrj] = useState(project);
    return (
        prj !== null && (
            <div className="project-box" key={project._id}>
                <div className="project-index">{index + 1}</div>
                <div className="project-title">
                    {project.name}
                    <div className="project-buttons">
                        <Link
                            className="btn-sm btn-primary project-button"
                            to={`/admin/projects/${project._id}`}
                            state={index}
                        >
                            <i className="fas fa-edit"></i>
                        </Link>
                        <Button
                            size="sm"
                            className="btn project-button"
                            onClick={() => {
                                deleteProject(project._id);
                                setPrj(null);
                            }}
                        >
                            <i className="fas fa-trash"></i>
                        </Button>
                    </div>
                </div>
            </div>
        )
    );
};

export default ProjectBox;
